import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'trunk',
      d: 'M-2,-4h1v1h-1zM-2,-3h1.5v1h-1.5zM2.5,-1h0.5v0.5h-0.5zM-3,-0.5h1v0.5h-1zM0.5,-0.5h0.5v0.5h-0.5zM2.5,-0.5h1v0.5h-1zM-3.5,0h2v1h-2zM0,0h1.5v1h-1.5zM3,0h0.5v0.5h-0.5zM0.5,1h0.5v0.5h-0.5z',
    },
    {
      paint: 'wagon',
      d: 'M-3.5,-2h1.5v0.5h-1.5zM-3.5,-1.5h3.5v1h-3.5zM2,-1.5h0.5v0.5h-0.5zM-3.5,-0.5h0.5v0.5h-0.5zM-2,-0.5h2v0.5h-2zM-1.5,0h1.5v0.5h-1.5zM-0.5,0.5h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['shadow', 0.24],
        ['wagon', 0.76],
      ],
      d: 'M1,-2h1.5v0.5h-1.5zM0,-1.5h2v0.5h-2zM0,-1h2.5v0.5h-2.5zM0,-0.5h0.5v0.5h-0.5zM1,-0.5h1.5v0.5h-1.5z',
    },
    {
      paint: 'sail',
      d: 'M-2,-5.5h0.5v0.5h-0.5zM-3,-5h2v0.5h-2zM-3.5,-4.5h1v0.5h-1zM-1.5,-4.5h1v0.5h-1zM-3.5,-4h0.5v0.5h-0.5zM-2.5,-4h0.5v0.5h-0.5zM-4,-3.5h2v1h-2zM-0.5,-3.5h0.5v2h-0.5zM-4,-2.5h1v0.5h-1z',
    },
    {
      paint: [
        ['sail', 0.76],
        ['shadow', 0.24],
      ],
      d: 'M-1,-5h2v0.5h-2zM-2.5,-4.5h1v0.5h-1zM-0.5,-4.5h2.5v0.5h-2.5zM-3,-4h0.5v0.5h-0.5zM-1,-4h3.5v0.5h-3.5zM0,-3.5h2.5v1h-2.5zM-3,-2.5h1v0.5h-1zM0,-2.5h2v0.5h-2zM-1.5,-2h1v0.5h-1zM0,-2h1v0.5h-1z',
    },
    { paint: 'fence', d: 'M-1,-3.5h0.5v0.5h-0.5z' },
    {
      paint: [
        ['sail', 0.22],
        ['wagon', 0.78],
      ],
      d: 'M2,-2.5h0.5v0.5h-0.5zM-2,-2h0.5v0.5h-0.5z',
    },
  ],
  pixels: 142,
};
export const sprites: readonly PixelSprite[] = [variant0, variant0, variant0];
